import { EnhancedLinkUnstyled } from '@ui/enhanced-components/enhanced-components'
import { type LinkUnstyledProps } from '@ui/link-unstyled'
import clsx from 'clsx'
import React, { type FC } from 'react'

export const CtaLink: FC<LinkUnstyledProps> = ({
  children,
  className,
  ...props
}) => (
  <EnhancedLinkUnstyled
    className={clsx(
      'text-085 font-medium leading-alternate text-theme-info-main underline underline-offset-8 hover:text-theme-selected-accent3 hover:underline group-[.is-blue]/section-template:text-text-inverse group-[.is-blue]/section-template:hover:text-theme-info-accent1',
      className
    )}
    {...props}
  >
    {children}
  </EnhancedLinkUnstyled>
)
